'use strict';
import getUrls from './getUrls';
import routerUtility from 'utils/routerUtility';
import ModuleAccessCodes from 'constants/moduleCodes';
import RoutePath from 'constants/routePath';
import { InspectionCoachLoader } from './loader';
import { handleLazyLoadError } from '../../helper/error-helper';


module.exports = {

  path: getUrls.getModuleUrl(),

  getIndexRoute(partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, {
        component: require('./views/home/homePage').default,
      }, 'inspection-coach')
    })
  },

  getComponent(nextState, callback) {
    var error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_INSPECTION_COACH);
    if (error === null) {
      InspectionCoachLoader.load(callback).catch(handleLazyLoadError);
    } else {
      callback(error);
    }
  },

  getChildRoutes(partialNextState, callback) {
    require.ensure([], function (require) {
        callback(null, [
          {
            path: 'questionnaires/:questionnaireId/topics/:topicId',
            component: require('./views/topic/topicPage').default
          },
          {
            path: 'self-evaluation',
            component: require('./views/selfEvaluation/selfEvaluationPage').default
          },
          {
            path: RoutePath.ROUTE_MY_PROFILE,
            component: require('../../component/profile/profilePage')
          },
          {
            path: RoutePath.ROUTE_NOT_FOUND,
            component: require('../../component/errors/notFoundPage')
          }
        ])
      },
      handleLazyLoadError,
      'inspection-coach');
  }
};
